// @ts-nocheck
import React from "react";
import { FC } from "react";
import { useEffect } from "react";
import { RouteComponentProps } from "react-router";
import { makeStyles } from "@material-ui/core";
import { Theme } from "@material-ui/core";
import { Container } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Button from "../../../../components/Button";
import { usePayment } from "../../hooks/usePayment";
import Divider from "@material-ui/core/Divider";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import PageHeader from "../../../../components/PageHeader";
import { AdapterLink } from "../../../../components/Adopter";
import Loading from "../../../../components/Loading";
import Error from "../../../../components/Error";
import FooterWave from "../../../../assets/img/footer-wave.png";
import FontIcon from "../../../../components/FontIcon";

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    minHeight: "70vh",
    backgroundImage: "linear-gradient(to bottom,#fff,#ece6d6)",
    position: "relative",
    paddingBottom: theme.spacing(4),

    "&:after": {
      content: "''",
      position: "absolute",
      top: "99.7%",
      height: 40,
      width: "100%",
      background: `url(${FooterWave}) top no-repeat`,
      backgroundSize: "100% 100%",
    },
  },
  paper: {
    paddingBottom: theme.spacing(4),
  },
  item: {
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.5),
    paddingRight: 0,
    paddingLeft: 0,
  },
  itemTitle: {
    paddingRight: theme.spacing(1),
  },
  total: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
}));

const CartPage: FC<RouteComponentProps> = ({ ...props }) => {
  const classes = useStyles();

  const {
    loadProducts,
    loadingProducts,
    data: { cart },
    actions: { removeFromCart },
  } = usePayment();

  useEffect(() => {
    loadProducts();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (loadingProducts) return <Loading />;

  return (
    <div className={classes.root}>
      <Container maxWidth={"lg"}>
        <PageHeader title={"Cart"} disableBackButton />
      </Container>
      <Container maxWidth={"lg"}>
        {cart.length === 0 ? (
          <Error text={"No items found"} />
        ) : (
          <Paper className={classes.paper}>
            <div>
              <Grid className={classes.item} container alignItems={"center"}>
                <Grid item xs={8} className={classes.itemTitle}>
                  <Typography variant={"body2"}>Product Name</Typography>
                </Grid>
                <Grid item xs={2}>
                  <Typography variant={"body2"} align={"center"}>
                    Price
                  </Typography>
                </Grid>
                <Grid item xs={2}>
                  <Typography variant={"body2"} align={"center"}>
                    Action
                  </Typography>
                </Grid>
              </Grid>
            </div>
            {cart.map((cartItem, index) => (
              <div key={`CartItem_${cartItem.id}`}>
                <Divider />
                <Grid className={classes.item} container alignItems={"center"}>
                  <Grid item xs={8} className={classes.itemTitle}>
                    <Typography variant={"body2"}>{cartItem.name}</Typography>
                  </Grid>
                  <Grid item xs={2}>
                    <Typography variant={"body2"} align={"right"}>
                      ${cartItem.price}
                    </Typography>
                  </Grid>
                  <Grid item xs={2}>
                    <Typography align={"center"}>
                      <IconButton onClick={() => removeFromCart(cartItem.id)}>
                        <FontIcon
                          fontSize={"small"}
                          color={"error"}
                          name={"delete"}
                        />
                      </IconButton>
                    </Typography>
                  </Grid>
                </Grid>
                {index === cart.length - 1 && <Divider />}
              </div>
            ))}
            <Typography align={"right"} className={classes.total}>
              <strong>
                Total: ${cart.reduce((total, item) => total + item.price, 0)}
              </strong>
            </Typography>
            <Typography align={"right"}>
              <Button
                component={AdapterLink}
                variant={"contained"}
                color={"secondary"}
                to={"/checkout"}
              >
                Checkout
              </Button>
            </Typography>
          </Paper>
        )}
      </Container>
    </div>
  );
};

export default CartPage;
